'use strict';

var React = require('react');

var SvgMarkPaidMinor = function SvgMarkPaidMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.207 6.793a1 1 0 0 1 0 1.414l-4.5 4.5a1 1 0 0 1-1.414 0l-2.5-2.5a1 1 0 0 1 1.414-1.414l1.793 1.793 3.793-3.793a1 1 0 0 1 1.414 0zm-9.707-3.793a1.5 1.5 0 0 0-1.5 1.5v12.5a1.002 1.002 0 0 0 1.301.953c.179-.056.315-.193.437-.336l1.122-1.322 1.349 1.399c.184.191.437.301.702.306a.96.96 0 0 0 .713-.281l1.364-1.317 1.305 1.305a.997.997 0 0 0 1.414 0l1.42-1.42 1.138 1.334c.12.14.254.275.43.331a1 1 0 0 0 1.305-.952v-12.5a1.5 1.5 0 0 0-1.5-1.5h-11z"
  }));
};

exports.SvgMarkPaidMinor = SvgMarkPaidMinor;
